/**
 * My Cars Initial State
 */

export type Car = {
  vehicle?: any;
  status?: string;
  data?: any;
  loanDetails?: any;
  bankInfo?: any;
};

export type MyCars = {
  cars: Car[];
  currentVehicle: {};
  myCarsAPIStatus: {
    isComplete: boolean;
    isError: boolean;
  };
  isContactDetailsComplete: boolean;
  isLoanDetailsInprogress: boolean;
};

export const myCarsInitialState: MyCars = {
  cars: [
    {
      vehicle: {},
      status: 'string',
      data: {},
    },
  ],
  currentVehicle: {},
  myCarsAPIStatus: {
    isComplete: false,
    isError: false,
  },
  isContactDetailsComplete: false,
  isLoanDetailsInprogress: false,
};
